import { createSelector } from 'reselect'
import { get } from 'utils/lodash'
import { selectMetaFilters } from 'api/meta/getMetaFilters'

export const getMetaFilters = createSelector(selectMetaFilters, (meta = {}) => get(meta, 'data', []))
